import getRegionalOptions from '../store/store';
import { mutatorAction } from 'satcheljs';
export default mutatorAction('selectTimeFormatOption', function selectTimeFormatOption(timeFormat) {
    var optionState = getRegionalOptions();
    optionState.selectedTimeFormat = timeFormat;
});
//# sourceMappingURL=selectTimeFormatOption.js.map